"use client";

import { CreateSiteSource } from "@/api-service/siteSource";
import { useEffect } from "react";
import HeaderFactory from "./HeaderFactory";

interface HeaderWrapperProps {
  showTopBar?: number;
  showPromotional?: number;
}

export default function HeaderWrapper({
  showTopBar = 1,
  showPromotional = 0,
}: HeaderWrapperProps) {
  useEffect(() => {
    const sendReferrer = async () => {
      try {
        const referrer = document.referrer;

        if (!referrer) return;

        const refUrl = new URL(referrer);
        const currentHost = window.location.host;

        if (refUrl.host === currentHost) {
          return;
        }

        const siteName = refUrl.hostname;

        await CreateSiteSource({
          sourceName: siteName,
          sourceUrl: refUrl.href,
          description: "User came from an external site",
        });
      } catch (error) {
        console.error("Error sending referrer:", error);
      }
    };

    sendReferrer();
  }, []);

  return (
    <HeaderFactory
      showTopBar={showTopBar}
      showPromotional={showPromotional}
    />
  );
}
